import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseHttpService } from '../../shared/services/base-http.service';
import { Observable } from 'rxjs/Rx';
import { Store } from '@ngrx/store';
import { Response, Headers, RequestOptionsArgs, RequestOptions, Http, ResponseContentType } from '@angular/http';
import { filter } from 'rxjs/operators';
import { IApplicationState } from '../../stateManagement/states/applicationState';
import * as stageTypes from '../types';
import { IResponse, IError } from '../../shared/types';
import { FileSaverService } from 'ngx-filesaver';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { environment } from '../../../environments/environment';
import { EnableBusyFlag, DisableBusyFlag } from '../../stateManagement/actions/containers/application';
import { callLifecycleHooksChildrenFirst } from '@angular/core/src/view/provider';
import { Location } from '@angular/common';

@Injectable()
export class StageService extends BaseHttpService {

  private uploader: FileUploader;
  private isUploadAll: boolean = false;
  private redirectTaskList: boolean = false;

  constructor(private http: Http, store: Store<IApplicationState>, public router: Router, public route: ActivatedRoute, private fileSaverService: FileSaverService, private location: Location) {
    super(store);
  }

  private getFullUrl(url: string): string {
    return environment.API_ENDPOINT + url;
  }

  public setTypeID(value: number) {
      this.typeId = value;
  }

  public setType(value: string) {
      this.type = value;
  }

  public setTaskID(value: number) {
      this.taskId = value;
  }

  public getType() {
      return this.type;
  }

  public getTypeID() {
      return this.typeId;
  }

  getUploaderService() {
    if (!this.uploader) {
      if(this.type == 'offboardee' && this.taskId > 0)
      {
        // when upload task attachment for offboard task question
        this.uploader = new FileUploader({
          url: this.getFullUrl(`user/${this.userId}/${this.type}/${this.typeId}/file/attachments/${this.taskId}`),
          authToken: `Bearer ${this.jwtToken}`,
          removeAfterUpload: false // if don't remove files from queue, it will keep uploading when navi page, unless do something manually in the stage.sandbox.ts
        });
      }
      else if(this.type == 'starter')
      {
        // when upload file in general for ob starter
        this.uploader = new FileUploader({
          url: this.getFullUrl(`user/${this.userId}/${this.type}/${this.typeId}/file/attachments`),
          authToken: `Bearer ${this.jwtToken}`,
          removeAfterUpload: false // if don't remove files from queue, it will keep uploading when navi page, unless do something manually in the stage.sandbox.ts
        });
      }
      else
      {
        // when upload task attachment for induction
        this.uploader = new FileUploader({
          url: this.getFullUrl(`user/${this.userId}/${this.type}/${this.typeId}/file/attachments`),
          authToken: `Bearer ${this.jwtToken}`,
          removeAfterUpload: false // if don't remove files from queue, it will keep uploading when navi page, unless do something manually in the stage.sandbox.ts
        });
      }

    }

    return this.uploader;
  }

  getStages(): Observable<stageTypes.IStarterResponse> {
    //console.log('get type: ' + this.type);
    return this.http.get(`user/${this.userId}/${this.type}/${this.typeId}`, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()));
  }

  // Where there is a task list we need to add the task to the API call only if we want to render individual task, otherwise render the task list
  // If not then that is ommited (as is the case with Starters)
  getStageDefinition(stageId: number): Observable<stageTypes.IStageResponse> {
    //console.log('load Stage :  stageId ' + stageId + ' taskId ' + this.taskId);

    if(this.type == 'starter') {
      var stagedata = this.http.get(`user/${this.userId}/${this.type}/${this.typeId}/stage/${stageId}`, this.authorizedHttpOptions());
    }
    else {
      // for induction and offboard stage 1, stage 2 and stage 3
      if (this.taskId > 0) {
        // Inductees and Offboardees do not have any stages maintained (always stage 1). So we create faux stages depedning on what is happening
        // individual task page(stage 1, 3)
        var stagedata = this.http.get(`user/${this.userId}/${this.type}/${this.typeId}/stage/2/task/${this.taskId}`, this.authorizedHttpOptions());
      } else {
        // task list page(stage 1, 3)
        var stagedata = this.http.get(`user/${this.userId}/${this.type}/${this.typeId}/stage/1`, this.authorizedHttpOptions());
      }
    }
    return stagedata.map(res => this.updateLocalAuthentication(res.json()));

  }

  checkStagePermission(stageId: number): Observable<boolean> {
    return this.http.get(`user/${this.userId}/${this.type}/${this.typeId}/stage/${stageId}/permission`, this.authorizedHttpOptions())
      .map(res => res.json());
  }

  downloadAttachment(url: string, authRequired?: boolean): Observable<any> {
    if (!authRequired) {
      return this.http.request(url, { responseType: ResponseContentType.Blob }).map(res => res);
    } else {
      return this.http.request(url, Object.assign(this.authorizedHttpOptions(), { responseType: ResponseContentType.Blob })).map(res => res.json());
    }
  }

  documentConfirmation(fileId: number): Observable<any> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/file/${fileId}/confirm`, {}, this.authorizedHttpOptions()).map(res => this.updateLocalAuthentication(res.json()));
  }

  serverAction(data: stageTypes.IAttachmentDownload): Observable<any> {
    return this.http.post(data.link, { absoluteUrl: '' }, this.authorizedHttpOptions()).map(res => this.updateLocalAuthentication(res.json()));
  }

  saveAttachment(blobContent: any, fileName: string): void {
    //Siddharth ADO-132784, Added encodeURI to the below fileName to fix a bug
    this.fileSaverService.save(blobContent, encodeURI(fileName));
  }

  acceptStage(): Observable<IResponse | IError> {
    //console.log('Accept: ' + this.type + ' stage ' + this.stageId);
    if(this.type == 'starter') {
      return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/accept`, {}, this.authorizedHttpOptions())
        .map(res => this.updateLocalAuthentication(res.json()))
        .catch(e => {
          let error = [{
            message: 'Error progressing to next stage',
            status: -1
          }];
          return Observable.from(error).first();
        });
    } else  {

      if (this.type == 'inductee' || this.type == 'offboardee')
      {
        // for induction and offboard
        console.log('redirect to task list.');
        this.location.back(); // go back to task list page after every page save for offboard only, accept stage happens after stage 2 save/patch
      }

      // induction and offboard accept stage (required but not doing anything actually)
      return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/2/accept`, {}, this.authorizedHttpOptions())
        .map(res => this.updateLocalAuthentication(res.json()))
        .catch(e => {
          let error = [{
            message: 'Error progressing to next stage',
            status: -1
          }];
          return Observable.from(error).first();
        });
    }
  }

  declineStage(): Observable<IResponse | IError> {
    if(this.type == 'starter') {
      return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/decline`, {}, this.authorizedHttpOptions())
        .map(res => this.updateLocalAuthentication(res.json()))
        .catch(e => {
          let error = [{
            message: 'Error progressing to next decline stage',
            status: -1
          }];
          return Observable.from(error).first();
        });
    }
  }

  queryOffer(bodyData: Object): Observable<IResponse> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/query`, bodyData, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()));

  }


  saveFormData(pageId: number, formData): Observable<IResponse> {
    console.log('Save: ' + this.type);
    // PATCH	/api/user/{id}/${this.type}/{id}/stage/{id}/page/{id}
    // tslint:disable-next-line:max-line-length
    if (this.type == 'starter') {
      return this.http.patch(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/page/${pageId}`, formData, this.authorizedHttpOptions())
        .map(res => this.updateLocalAuthentication(res.json()));
    } else {
      // induction and offboard
      return this.http.patch(`user/${this.userId}/${this.type}/${this.typeId}/stage/2/task/${this.taskId}`, formData, this.authorizedHttpOptions())
        .map(res => this.updateLocalAuthentication(res.json()));
    }

  }

  verifyCode(code: string, secret: string): Observable<IResponse> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/accept`, {
      smssecret: secret,
      smscode: code
    }, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()))
      .catch(e => {
        return Observable.of(Object.assign({}, { error: true, detail: e.json() }));
      });
  }

  verifyDeclineOfferCode(code: string, secret: string): Observable<IResponse> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/stage/${this.stageId}/decline`, {
      smssecret: secret,
      smscode: code
    }, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()))
      .catch(e => {
        return Observable.of(Object.assign({}, { error: true, detail: e.json() }));
      });
  }

  ///api/user/{id}/${this.type}/{id}/sms/sendverificationsms
  resendSMS(mobNumber: string, secret: string): Observable<IResponse> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/sms/sendverificationsms`, {
      "mobile": mobNumber
    }, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()))
      .catch(e => {
        return Observable.of(Object.assign({}, { error: true, detail: e.json() }));
      });
  }

  resendEmailCode(): Observable<IResponse> {
    return this.http.post(`user/${this.userId}/${this.type}/${this.typeId}/sendverificationemail`, {}, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()))
      .catch(e => {
        return Observable.of(Object.assign({}, { error: true, detail: e.json() }));
      });
  }
  
  confirmDocument(name: string, href: string) {
    return this.http.post(href, { "name": name }, this.authorizedHttpOptions())
      .map(res => this.updateLocalAuthentication(res.json()))
      .catch(e => {
        let error = [{
          message: 'Error confirming document',
          status: -1
        }];
        return Observable.from(error).first();
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/services/stage.service.ts